module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('header', [_c('h1', {
    staticClass: "blog-title"
  }, [_c('router-link', {
    attrs: {
      "to": {
        name: 'list'
      }
    }
  }, [_vm._v(_vm._s(_vm.blogTitle) + "\n      ")])], 1), _vm._v(" "), _c('nav', [_c('a', {
    attrs: {
      "href": _vm.profileAddress,
      "target": "_blank"
    }
  }, [_c('i', {
    staticClass: "fa fa-github",
    attrs: {
      "aria-hidden": "true"
    }
  })])])]), _vm._v(" "), _c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in",
      "appear": ""
    }
  }, [_c('router-view', {
    staticClass: "sticky-main"
  })], 1), _vm._v(" "), _c('footer', [_vm._v("\n    Created by\n    "), _c('a', {
    attrs: {
      "href": _vm.profileAddress
    }
  }, [_vm._v("TL")])])], 1)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4866abf7","hasScoped":false}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/App.vue
// module id = 359
// module chunks = 0